module.exports = __webpack_public_path__ + "img/diploma.7487f1f9.jpg";